import { Dictionary } from "../../../../../types";
import { StoreFeature } from "../../../core/store/types";

export interface FilterType extends Dictionary<string, any>
{
    typeIdentifier: string;
    filter: any;
}

export const filterType: StoreFeature<FilterType> =
{
    getPostData: (state: FilterType, store) =>
    {
        return {
            filterTypeIdentifier: state.typeIdentifier,
            filterType: JSON.stringify(state),
            filterTypeHash: store.hashes["filterType"]
        };
    }
};